// How a payment attempt failed, so PaymentForm can offer the right recovery UX:
// - DECLINED: the card was definitively declined (or never tokenized) and was NOT charged. Safe to
//   retry — the parker re-enters their card and we re-initiate a fresh session against the same permit.
// - UNCONFIRMED: the request timed out / errored without a confirmed outcome, so the charge state is
//   unknown. The parker must NOT one-click retry (risk of a double charge); they check their permits/email.

const PAYMENT_FORM_ERRORS = ["declined", "unconfirmed"] as const;

export type PaymentFormError = (typeof PAYMENT_FORM_ERRORS)[number];

export const PaymentFormError = {
	DECLINED: "declined",
	UNCONFIRMED: "unconfirmed",
} as const satisfies Record<Uppercase<PaymentFormError>, PaymentFormError>;

export type GatewayPaymentError =
	| {
			type: string;
			code?: string;
			decline_code?: string;
			message?: string;
	  }
	| {
			message: string;
			authorizeNetDeclineCode?: string;
	  }
	| undefined;
